import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {KeyValuePipe} from '@angular/common';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {faFile} from '@fortawesome/pro-solid-svg-icons';
import {BicBadgeComponent, TooltipDirective} from '@buildinginformationcloud/bic-ui-components';
import {ReportFileSummary} from '../../../api';

/**
 * Geprüfte Dateien eines Berichts als Badge „N Dateien“. Der dunkle Tooltip zeigt die Anzahl je
 * Dateityp, eine Vorschau von bis zu fünf Namen und „+ N weitere“ (Figma „Tooltip – Dateien“).
 */
@Component({
  selector: 'app-report-files-badge',
  templateUrl: './report-files-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BicBadgeComponent, TooltipDirective, FaIconComponent, KeyValuePipe],
})
export class ReportFilesBadgeComponent {
  @Input({required: true}) files!: ReportFileSummary | null;

  protected readonly faFile = faFile;
  /** Breite der Tooltip-Blase laut Figma (272 px Inhalt + Innenabstand). */
  protected readonly tooltipWidth = 296;
  /** Die Typ-Badges in der Reihenfolge des ersten Auftretens, nicht alphabetisch. */
  protected readonly keepOrder = (): number => 0;

  get total(): number {
    return this.files?.total ?? 0;
  }

  get label(): string {
    return this.total === 1 ? '1 Datei' : `${this.total} Dateien`;
  }

  get title(): string {
    return `${this.label} geprüft`;
  }

  get remaining(): number {
    return Math.max(0, this.total - (this.files?.preview?.length ?? 0));
  }
}
